// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sashe-page {
  padding: 30px;
  max-width: 1400px;
  margin: 0 auto;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  color: #1f2937;
  font-size: 2.5rem;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 15px;
}

/* Next Run Countdown */
.next-run-box {
  display: flex;
  align-items: center;
  gap: 20px;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border: 2px solid #22c55e;
  border-radius: 12px;
  padding: 16px 24px;
  margin-bottom: 24px;
}

.next-run-icon {
  font-size: 1.5rem;
  color: #16a34a;
}

.next-run-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.next-run-label {
  font-size: 0.8rem;
  color: #166534;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.next-run-time {
  font-size: 1rem;
  color: #15803d;
  font-weight: 600;
}

.next-run-countdown {
  margin-left: auto;
  font-size: 1.6rem;
  font-weight: 700;
  color: #16a34a;
  font-variant-numeric: tabular-nums;
}

[data-theme="dark"] .next-run-box {
  background: linear-gradient(135deg, rgba(22, 163, 74, 0.15) 0%, rgba(34, 197, 94, 0.1) 100%);
  border: 2px solid rgba(34, 197, 94, 0.3);
}

[data-theme="dark"] .next-run-icon {
  color: #4ade80;
}

[data-theme="dark"] .next-run-label {
  color: #86efac;
}

[data-theme="dark"] .next-run-time {
  color: #bbf7d0;
}

[data-theme="dark"] .next-run-countdown {
  color: #4ade80;
}

/* Columns Layout */
.columns-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-bottom: 30px;
}

.shop-column {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.column-header {
  padding: 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #e5e7eb 100%);
  border-bottom: 3px solid;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.column-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.column-title h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #1f2937;
}

.column-stats {
  display: flex;
  align-items: center;
  gap: 15px;
}

.column-stats .stat {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  background: white;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #4b5563;
}

.column-actions {
  padding: 15px 20px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: center;
}

.column-actions .btn {
  width: 100%;
  max-width: 250px;
  justify-content: center;
}

.refresh-btn {
  padding: 8px;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.refresh-btn:hover {
  background: #f3f4f6;
  transform: rotate(180deg);
}

.refresh-btn svg {
  color: #6b7280;
}

/* Products List */
.products-list {
  padding: 20px;
  min-height: 400px;
  max-height: 600px;
  overflow-y: auto;
}

.empty-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #9ca3af;
}

.empty-icon {
  font-size: 3rem;
  margin-bottom: 15px;
  opacity: 0.5;
}

/* Product Card */
.product-card {
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  margin-bottom: 12px;
  overflow: hidden;
  cursor: grab;
  transition: all 0.3s ease;
}

.product-card:active {
  cursor: grabbing;
}

.product-card:hover {
  border-color: #d1d5db;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.product-card-header {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}

.drag-handle {
  margin-right: 12px;
  cursor: grab;
  color: #9ca3af;
  display: flex;
  align-items: center;
}

.drag-handle:active {
  cursor: grabbing;
}

.product-status {
  margin-right: auto;
}

.product-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.delete-btn,
.refresh-single-btn {
  padding: 6px;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-btn {
  color: #ef4444;
}

.delete-btn:hover {
  background: #fee2e2;
  border-radius: 4px;
  transform: scale(1.1);
}

.refresh-single-btn {
  color: #3b82f6;
}

.refresh-single-btn:hover {
  background: #dbeafe;
  border-radius: 4px;
  transform: scale(1.1);
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg) scale(1.1); }
  to { transform: rotate(360deg) scale(1.1); }
}

.product-card-body {
  padding: 15px;
}

.product-card-body h4 {
  margin: 0 0 10px 0;
  color: #1f2937;
  font-size: 1.1rem;
}

.product-meta {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.product-meta .date {
  font-size: 0.85rem;
  color: #6b7280;
}

/* Status Icons */
.status-icon {
  font-size: 1.2rem;
}

.status-icon.waiting {
  color: #f59e0b;
}

.status-icon.processing {
  color: #3b82f6;
}

.status-icon.completed {
  color: #10b981;
}

.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Form Styles */
.add-form-container {
  background: white;
  border-radius: 12px;
  padding: 25px;
  margin-bottom: 30px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.product-form {
  max-width: 800px;
  margin: 0 auto;
}

.form-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.input-group {
  display: flex;
  flex-direction: column;
}

.input-group label {
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
}

.input-group input,
.input-group select {
  padding: 10px 12px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.input-group input:focus,
.input-group select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

/* Buttons */
.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1rem;
}

.btn-primary {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
}

.btn-success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
}

.btn-success:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
}

.btn-success.processing {
  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
  cursor: not-allowed;
}

.btn-secondary {
  background: #6b7280;
  color: white;
}

.btn-secondary:hover {
  background: #4b5563;
}

/* Info Box */
.info-box {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border: 2px solid #3b82f6;
  border-radius: 12px;
  padding: 20px;
  margin-top: 30px;
}

.info-box h3 {
  margin: 0 0 15px 0;
  color: #1e40af;
}

.info-box p {
  margin: 10px 0;
  color: #1e40af;
  line-height: 1.6;
}

.info-box strong {
  color: #1e3a8a;
}

/* Loading */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 100px 20px;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #e5e7eb;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Scrollbar Styling */
.products-list::-webkit-scrollbar {
  width: 8px;
}

.products-list::-webkit-scrollbar-track {
  background: #f3f4f6;
  border-radius: 4px;
}

.products-list::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 4px;
}

.products-list::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

/* Responsive Design */
@media (max-width: 968px) {
  .columns-container {
    grid-template-columns: 1fr;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .header-actions {
    width: 100%;
  }

  .btn {
    flex: 1 1;
    justify-content: center;
  }
}

/* ============ DARK THEME OVERRIDES ============ */
[data-theme="dark"] .page-header {
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
}

[data-theme="dark"] .page-header h1 {
  color: var(--text-primary);
}

[data-theme="dark"] .shop-column {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

[data-theme="dark"] .column-header {
  background: rgba(15, 23, 42, 0.8);
  border-bottom: 3px solid;
}

[data-theme="dark"] .column-title h2 {
  color: var(--text-primary);
}

[data-theme="dark"] .column-stats .stat {
  background: rgba(255, 255, 255, 0.05);
  color: rgba(226, 232, 240, 0.75);
}

[data-theme="dark"] .column-actions {
  background: rgba(15, 23, 42, 0.4);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

[data-theme="dark"] .refresh-btn {
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(255, 255, 255, 0.1);
}

[data-theme="dark"] .refresh-btn:hover {
  background: rgba(255, 255, 255, 0.08);
}

[data-theme="dark"] .refresh-btn svg {
  color: rgba(226, 232, 240, 0.75);
}

[data-theme="dark"] .empty-column {
  color: rgba(226, 232, 240, 0.5);
}

[data-theme="dark"] .product-card {
  background: rgba(15, 23, 42, 0.4);
  border: 2px solid rgba(255, 255, 255, 0.08);
}

[data-theme="dark"] .product-card:hover {
  border-color: rgba(226, 232, 240, 0.2);
}

[data-theme="dark"] .product-card-header {
  background: rgba(15, 23, 42, 0.6);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

[data-theme="dark"] .drag-handle {
  color: rgba(226, 232, 240, 0.5);
}

[data-theme="dark"] .product-card-body h4 {
  color: var(--text-primary);
}

[data-theme="dark"] .product-meta .date {
  color: rgba(226, 232, 240, 0.6);
}

[data-theme="dark"] .add-form-container {
  background: rgba(15, 23, 42, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

[data-theme="dark"] .input-group label {
  color: rgba(226, 232, 240, 0.9);
}

[data-theme="dark"] .input-group input,
[data-theme="dark"] .input-group select {
  background: rgba(15, 23, 42, 0.6);
  color: var(--text-primary);
  border: 2px solid rgba(255, 255, 255, 0.15);
}

[data-theme="dark"] .input-group input:focus,
[data-theme="dark"] .input-group select:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(203, 213, 225, 0.2);
}

[data-theme="dark"] .info-box {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.15) 0%, rgba(37, 99, 235, 0.1) 100%);
  border: 2px solid rgba(59, 130, 246, 0.3);
}

[data-theme="dark"] .info-box h3 {
  color: #93c5fd;
}

[data-theme="dark"] .info-box p {
  color: #bfdbfe;
}

[data-theme="dark"] .info-box strong {
  color: #dbeafe;
}

[data-theme="dark"] .loading-spinner {
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-top-color: var(--primary-color);
}

[data-theme="dark"] .products-list::-webkit-scrollbar-track {
  background: rgba(15, 23, 42, 0.4);
}

[data-theme="dark"] .products-list::-webkit-scrollbar-thumb {
  background: rgba(226, 232, 240, 0.3);
}

[data-theme="dark"] .products-list::-webkit-scrollbar-thumb:hover {
  background: rgba(226, 232, 240, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/features/sashe/Sashe.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,4FAA4F;EAC5F,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,wBAAwB;EACxB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,OAAO,kCAAkC,EAAE;EAC3C,KAAK,oCAAoC,EAAE;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,uBAAuB;EACzB;AACF;;AAEA,mDAAmD;AACnD;EACE,iDAAiD;AACnD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,kDAAkD;AACpD;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,kDAAkD;AACpD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,iCAAiC;EACjC,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;;EAEE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,6FAA6F;EAC7F,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".sashe-page {\n  padding: 30px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.page-header h1 {\n  color: #1f2937;\n  font-size: 2.5rem;\n  margin: 0;\n}\n\n.header-actions {\n  display: flex;\n  gap: 15px;\n}\n\n/* Next Run Countdown */\n.next-run-box {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);\n  border: 2px solid #22c55e;\n  border-radius: 12px;\n  padding: 16px 24px;\n  margin-bottom: 24px;\n}\n\n.next-run-icon {\n  font-size: 1.5rem;\n  color: #16a34a;\n}\n\n.next-run-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.next-run-label {\n  font-size: 0.8rem;\n  color: #166534;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.next-run-time {\n  font-size: 1rem;\n  color: #15803d;\n  font-weight: 600;\n}\n\n.next-run-countdown {\n  margin-left: auto;\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: #16a34a;\n  font-variant-numeric: tabular-nums;\n}\n\n[data-theme=\"dark\"] .next-run-box {\n  background: linear-gradient(135deg, rgba(22, 163, 74, 0.15) 0%, rgba(34, 197, 94, 0.1) 100%);\n  border: 2px solid rgba(34, 197, 94, 0.3);\n}\n\n[data-theme=\"dark\"] .next-run-icon {\n  color: #4ade80;\n}\n\n[data-theme=\"dark\"] .next-run-label {\n  color: #86efac;\n}\n\n[data-theme=\"dark\"] .next-run-time {\n  color: #bbf7d0;\n}\n\n[data-theme=\"dark\"] .next-run-countdown {\n  color: #4ade80;\n}\n\n/* Columns Layout */\n.columns-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 30px;\n  margin-bottom: 30px;\n}\n\n.shop-column {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.column-header {\n  padding: 20px;\n  background: linear-gradient(135deg, #f8fafc 0%, #e5e7eb 100%);\n  border-bottom: 3px solid;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.column-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.column-title h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #1f2937;\n}\n\n.column-stats {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.column-stats .stat {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 10px;\n  background: white;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #4b5563;\n}\n\n.column-actions {\n  padding: 15px 20px;\n  background: #f9fafb;\n  border-bottom: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: center;\n}\n\n.column-actions .btn {\n  width: 100%;\n  max-width: 250px;\n  justify-content: center;\n}\n\n.refresh-btn {\n  padding: 8px;\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.refresh-btn:hover {\n  background: #f3f4f6;\n  transform: rotate(180deg);\n}\n\n.refresh-btn svg {\n  color: #6b7280;\n}\n\n/* Products List */\n.products-list {\n  padding: 20px;\n  min-height: 400px;\n  max-height: 600px;\n  overflow-y: auto;\n}\n\n.empty-column {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #9ca3af;\n}\n\n.empty-icon {\n  font-size: 3rem;\n  margin-bottom: 15px;\n  opacity: 0.5;\n}\n\n/* Product Card */\n.product-card {\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 10px;\n  margin-bottom: 12px;\n  overflow: hidden;\n  cursor: grab;\n  transition: all 0.3s ease;\n}\n\n.product-card:active {\n  cursor: grabbing;\n}\n\n.product-card:hover {\n  border-color: #d1d5db;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.product-card-header {\n  display: flex;\n  align-items: center;\n  padding: 12px 15px;\n  background: #f9fafb;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.drag-handle {\n  margin-right: 12px;\n  cursor: grab;\n  color: #9ca3af;\n  display: flex;\n  align-items: center;\n}\n\n.drag-handle:active {\n  cursor: grabbing;\n}\n\n.product-status {\n  margin-right: auto;\n}\n\n.product-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.delete-btn,\n.refresh-single-btn {\n  padding: 6px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.delete-btn {\n  color: #ef4444;\n}\n\n.delete-btn:hover {\n  background: #fee2e2;\n  border-radius: 4px;\n  transform: scale(1.1);\n}\n\n.refresh-single-btn {\n  color: #3b82f6;\n}\n\n.refresh-single-btn:hover {\n  background: #dbeafe;\n  border-radius: 4px;\n  transform: scale(1.1);\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg) scale(1.1); }\n  to { transform: rotate(360deg) scale(1.1); }\n}\n\n.product-card-body {\n  padding: 15px;\n}\n\n.product-card-body h4 {\n  margin: 0 0 10px 0;\n  color: #1f2937;\n  font-size: 1.1rem;\n}\n\n.product-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.product-meta .date {\n  font-size: 0.85rem;\n  color: #6b7280;\n}\n\n/* Status Icons */\n.status-icon {\n  font-size: 1.2rem;\n}\n\n.status-icon.waiting {\n  color: #f59e0b;\n}\n\n.status-icon.processing {\n  color: #3b82f6;\n}\n\n.status-icon.completed {\n  color: #10b981;\n}\n\n.spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Form Styles */\n.add-form-container {\n  background: white;\n  border-radius: 12px;\n  padding: 25px;\n  margin-bottom: 30px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.product-form {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.input-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.input-group label {\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 8px;\n}\n\n.input-group input,\n.input-group select {\n  padding: 10px 12px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.input-group input:focus,\n.input-group select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.form-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n/* Buttons */\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 1rem;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  color: white;\n}\n\n.btn-primary:hover {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n}\n\n.btn-success {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n}\n\n.btn-success:hover {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n}\n\n.btn-success.processing {\n  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  background: #6b7280;\n  color: white;\n}\n\n.btn-secondary:hover {\n  background: #4b5563;\n}\n\n/* Info Box */\n.info-box {\n  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);\n  border: 2px solid #3b82f6;\n  border-radius: 12px;\n  padding: 20px;\n  margin-top: 30px;\n}\n\n.info-box h3 {\n  margin: 0 0 15px 0;\n  color: #1e40af;\n}\n\n.info-box p {\n  margin: 10px 0;\n  color: #1e40af;\n  line-height: 1.6;\n}\n\n.info-box strong {\n  color: #1e3a8a;\n}\n\n/* Loading */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 100px 20px;\n}\n\n.loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid #e5e7eb;\n  border-top-color: #3b82f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Scrollbar Styling */\n.products-list::-webkit-scrollbar {\n  width: 8px;\n}\n\n.products-list::-webkit-scrollbar-track {\n  background: #f3f4f6;\n  border-radius: 4px;\n}\n\n.products-list::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 4px;\n}\n\n.products-list::-webkit-scrollbar-thumb:hover {\n  background: #9ca3af;\n}\n\n/* Responsive Design */\n@media (max-width: 968px) {\n  .columns-container {\n    grid-template-columns: 1fr;\n  }\n\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .page-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n\n  .header-actions {\n    width: 100%;\n  }\n\n  .btn {\n    flex: 1;\n    justify-content: center;\n  }\n}\n\n/* ============ DARK THEME OVERRIDES ============ */\n[data-theme=\"dark\"] .page-header {\n  border-bottom: 2px solid rgba(255, 255, 255, 0.1);\n}\n\n[data-theme=\"dark\"] .page-header h1 {\n  color: var(--text-primary);\n}\n\n[data-theme=\"dark\"] .shop-column {\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n[data-theme=\"dark\"] .column-header {\n  background: rgba(15, 23, 42, 0.8);\n  border-bottom: 3px solid;\n}\n\n[data-theme=\"dark\"] .column-title h2 {\n  color: var(--text-primary);\n}\n\n[data-theme=\"dark\"] .column-stats .stat {\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(226, 232, 240, 0.75);\n}\n\n[data-theme=\"dark\"] .column-actions {\n  background: rgba(15, 23, 42, 0.4);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n[data-theme=\"dark\"] .refresh-btn {\n  background: rgba(255, 255, 255, 0.05);\n  border: 2px solid rgba(255, 255, 255, 0.1);\n}\n\n[data-theme=\"dark\"] .refresh-btn:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n[data-theme=\"dark\"] .refresh-btn svg {\n  color: rgba(226, 232, 240, 0.75);\n}\n\n[data-theme=\"dark\"] .empty-column {\n  color: rgba(226, 232, 240, 0.5);\n}\n\n[data-theme=\"dark\"] .product-card {\n  background: rgba(15, 23, 42, 0.4);\n  border: 2px solid rgba(255, 255, 255, 0.08);\n}\n\n[data-theme=\"dark\"] .product-card:hover {\n  border-color: rgba(226, 232, 240, 0.2);\n}\n\n[data-theme=\"dark\"] .product-card-header {\n  background: rgba(15, 23, 42, 0.6);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n[data-theme=\"dark\"] .drag-handle {\n  color: rgba(226, 232, 240, 0.5);\n}\n\n[data-theme=\"dark\"] .product-card-body h4 {\n  color: var(--text-primary);\n}\n\n[data-theme=\"dark\"] .product-meta .date {\n  color: rgba(226, 232, 240, 0.6);\n}\n\n[data-theme=\"dark\"] .add-form-container {\n  background: rgba(15, 23, 42, 0.7);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n[data-theme=\"dark\"] .input-group label {\n  color: rgba(226, 232, 240, 0.9);\n}\n\n[data-theme=\"dark\"] .input-group input,\n[data-theme=\"dark\"] .input-group select {\n  background: rgba(15, 23, 42, 0.6);\n  color: var(--text-primary);\n  border: 2px solid rgba(255, 255, 255, 0.15);\n}\n\n[data-theme=\"dark\"] .input-group input:focus,\n[data-theme=\"dark\"] .input-group select:focus {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(203, 213, 225, 0.2);\n}\n\n[data-theme=\"dark\"] .info-box {\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.15) 0%, rgba(37, 99, 235, 0.1) 100%);\n  border: 2px solid rgba(59, 130, 246, 0.3);\n}\n\n[data-theme=\"dark\"] .info-box h3 {\n  color: #93c5fd;\n}\n\n[data-theme=\"dark\"] .info-box p {\n  color: #bfdbfe;\n}\n\n[data-theme=\"dark\"] .info-box strong {\n  color: #dbeafe;\n}\n\n[data-theme=\"dark\"] .loading-spinner {\n  border: 4px solid rgba(255, 255, 255, 0.1);\n  border-top-color: var(--primary-color);\n}\n\n[data-theme=\"dark\"] .products-list::-webkit-scrollbar-track {\n  background: rgba(15, 23, 42, 0.4);\n}\n\n[data-theme=\"dark\"] .products-list::-webkit-scrollbar-thumb {\n  background: rgba(226, 232, 240, 0.3);\n}\n\n[data-theme=\"dark\"] .products-list::-webkit-scrollbar-thumb:hover {\n  background: rgba(226, 232, 240, 0.5);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
